'use client';

import React, { useMemo, useState } from 'react';
import debounce from 'lodash/debounce';
import { useRouter, useSearchParams } from 'next/navigation';

import { Input } from '@/components';
import { useTranslation } from '@/hooks';

const SearchFaq: React.FC = () => {
  const { t } = useTranslation('pages.faq');
  const router = useRouter();
  const searchParams = useSearchParams();
  const [searchValue, setSearchValue] = useState(
    searchParams.get('search') || ''
  );

  const debouncedFilterFaqs = useMemo(
    () =>
      debounce((query: string) => {
        const params = new URLSearchParams(searchParams.toString());
        if (query.length === 0) {
          params.delete('search');
        } else {
          params.set('search', query);
        }
        params.delete('page');
        router.push(`?${params.toString()}`, { scroll: false });
      }, 300),
    [router, searchParams]
  );

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    setSearchValue(value);
    debouncedFilterFaqs(value);
  };

  return (
    <Input
      border="none"
      shadow="none"
      _focus={{
        boxShadow: 'none',
      }}
      focusBorderColor="none"
      onChange={handleSearchChange}
      placeholder={t('searchInFaq')}
      borderRadius="sm"
      isSearch
      value={searchValue}
      h={{ base: '40px', md: '76px' }}
    />
  );
};

export default SearchFaq;
